import React from 'react'
import { Link } from "react-router-dom";
import { avater } from '../../utils/Constants';
import Countdown from "react-countdown";


const Coundown = ({ countdown }) => {


    // Random component
    const Completionist = () => {
        return (
            <div className="countDownTime">
                <p>
                    <span id="date_hours"> 00 </span> : <span id="date_minutes"> 00 </span> : <span
                        id="date_seconds"> 00 </span>
                </p>
            </div>
        )
    };

    // Renderer callback with condition
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a complete state
            return <Completionist />;
        } else {
            // Render a countdown
            return (
                <p><span id="date_hourds"> {days} </span> : <span id="date_hours"> {hours} </span> : <span id="date_minutes"> {minutes} </span> : <span
                    id="date_seconds"> {seconds} </span></p>
            );
        }
    };



    return (
        <div className="countDownTime">
            <Countdown date={countdown} renderer={renderer} />
        </div>
    )
};

export default Coundown
